var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReception({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#ED9082",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.875 6H6.75C6.65055 6 6.55516 5.96049 6.48484 5.89017C6.41451 5.81984 6.375 5.72446 6.375 5.625V3C6.375 2.90054 6.41451 2.80516 6.48484 2.73483C6.55516 2.66451 6.65055 2.625 6.75 2.625H9.75C9.84946 2.625 9.94484 2.66451 10.0152 2.73483C10.0855 2.80516 10.125 2.90054 10.125 3V5.625C10.125 5.72446 10.0855 5.81984 10.0152 5.89017C9.94484 5.96049 9.84946 6 9.75 6H8.625V6.375H9.70875C10.0181 6.375 10.3147 6.49787 10.5334 6.71659C10.7521 6.9353 10.875 7.23194 10.875 7.54125V9.33375C10.875 9.64306 10.7521 9.9397 10.5334 10.1584C10.3147 10.3771 10.0181 10.5 9.70875 10.5H3.79125C3.48194 10.5 3.1853 10.3771 2.96659 10.1584C2.74787 9.9397 2.625 9.64306 2.625 9.33375V7.54125C2.625 7.23194 2.74787 6.9353 2.96659 6.71659C3.1853 6.49787 3.48194 6.375 3.79125 6.375H7.875V6ZM7.875 5.25H7.125V3.375H9.375V5.25H8.625V4.5C8.625 4.40054 8.58549 4.30516 8.51517 4.23484C8.44484 4.16451 8.34946 4.125 8.25 4.125C8.15054 4.125 8.05516 4.16451 7.98484 4.23484C7.91451 4.30516 7.875 4.40054 7.875 4.5V5.25ZM8.24899 7.125H3.79125C3.68085 7.125 3.57498 7.16885 3.49692 7.24692C3.41885 7.32498 3.375 7.43085 3.375 7.54125V9.33375C3.375 9.44415 3.41885 9.55002 3.49692 9.62808C3.57498 9.70615 3.68085 9.75 3.79125 9.75H9.70875C9.81915 9.75 9.92502 9.70615 10.0031 9.62808C10.0811 9.55002 10.125 9.44415 10.125 9.33375V7.54125C10.125 7.43085 10.0811 7.32498 10.0031 7.24692C9.92502 7.16885 9.81915 7.125 9.70875 7.125H8.25102C8.25068 7.125 8.25034 7.125 8.25 7.125C8.24966 7.125 8.24932 7.125 8.24899 7.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReception);
export default __webpack_public_path__ + "static/media/icon-reception.3cea55d522cbe537aa0af2eb49c95af7.svg";
export { ForwardRef as ReactComponent };